import { render, staticRenderFns } from "./trans-field.vue?vue&type=template&id=49442056&scoped=true&"
import script from "./trans-field.vue?vue&type=script&lang=js&"
export * from "./trans-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49442056",
  null
  
)

export default component.exports